/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway.scss';

import 'brace/ext/language_tools';
import 'brace/mode/json';
import 'brace/theme/github';

/* eslint-disable import/no-unresolved, import/default */

import gatewayFieldsetTemplate from './gateway-fieldset.tpl.html';
import spectrumAnalyzerDialogTemplate from './spectrum-analyzer/spectrum-analyzer.dialog.tpl.html';
import spectralScanDialogTemplate from './spectral-scan/spectral-scan.dialog.tpl.html';
import radioStatisticsDialogTemplate from './radio-statistics/radio-statistics.dialog.tpl.html';
import gatewayInfoDialogTemplate from './gateway-info/gateway-info.dialog.tpl.html';
import wmFirmwareTemplate from './wm-firmware/wm-firmware.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

const defaultMapZoom = 12;

/*@ngInject*/
export default function GatewayDirective($rootScope, $compile, $templateCache, $translate, $mdUtil, $filter, $mdMedia, $mdDialog,
                                         $document, types, gatewayService, gatewayModelService, gatewayCommandService, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayFieldsetTemplate);
        element.html(template);

        scope.types = types;

        scope.statsQuery = {
            timewindow: {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            },
            order: '-ts',
            limit: 15,
            page: 1,
            search: null
        };

        scope.statsLimitOptions =
            [15, 30, 45];

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
            if (scope.isGtMd) {
                scope.statsLimitOptions = [15, 30, 45];
            } else {
                scope.statsLimitOptions = null;
            }
        });

        scope.gatewayCommand = {
            command: null,
            params: {},
            commandOutput: ''
        };

        scope.commandOutputOptions = {
            useWrapMode: false,
            mode: 'json',
            showGutter: false,
            showPrintMargin: false,
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            }
        };

        scope.$watch('gateway.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    updateGatewayLocation();
                    updateGatewayStatsRows();
                    createGatewaySubscriptions();
                }
            }
        });

        scope.$watch('gateway.gatewayModelId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                loadGatewayFrequencyInfo();
            }
        });

        scope.$watch('gatewayCommand.command', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                scope.gatewayCommand.params = {};
                scope.gatewayCommand.commandOutput = '';
                if (scope.gatewayCommand.command == types.gatewayCommand.reverseSsh.value) {
                    scope.gatewayCommand.params.options = types.gatewayCommand.reverseSsh.defaultOptions;
                }
            }
        });

        scope.onGatewayIdCopied = function() {
            toast.showSuccess($translate.instant('gateway.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.openSpectrumAnalyzer = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectrumAnalyzerController',
                controllerAs: 'vm',
                templateUrl: spectrumAnalyzerDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openSpectralScan = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectralScanController',
                controllerAs: 'vm',
                templateUrl: spectralScanDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openRadioStatistics = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'RadioStatisticsController',
                controllerAs: 'vm',
                templateUrl: radioStatisticsDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openGatewayInfo = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'GatewayInfoController',
                controllerAs: 'vm',
                templateUrl: gatewayInfoDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openWmFirmwareDialog = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'WmFirmwareController',
                controllerAs: 'vm',
                templateUrl: wmFirmwareTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.toggleGatewayState = function() {
            var promise = scope.gateway.disabled ? gatewayService.enableGateway(scope.gateway.id.id)
                : gatewayService.disableGateway(scope.gateway.id.id);
            promise.then(
                () => {
                    scope.gateway.disabled = !scope.gateway.disabled;
                    updateGatewayStateParameters();
                    $rootScope.$broadcast('reloadEntityDetails');
                    $rootScope.$broadcast('entityUpdated', scope.gateway);
                }
            );
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 1) {
                    scope.selectedTab = 0;
                }
                updateGatewayLocation();
            }
        });

        scope.$watch("statsQuery.search", function(newVal, prevVal) {
            if (!angular.equals(newVal, prevVal) && scope.statsQuery.search != null) {
                updateGatewayStatsRows();
            }
        });

        scope.$on("$destroy", function () {
            reset();
        });

        scope.enterGatewayStatisticsFilterMode = function () {
            scope.statsQuery.search = '';
        };

        scope.exitGatewayStatisticsFilterMode = function () {
            scope.statsQuery.search = null;
            updateGatewayStatsRows();
        };

        scope.onGatewayStatisticsReorder = function () {
            updateGatewayStatsRows();
        };

        scope.onGatewayStatisticsPaginate = function () {
            updateGatewayStatsRows();
        };

        scope.executeGatewayCommand = function () {
            gatewayCommandService.executeCommand(scope.gateway.id.id,
                scope.gatewayCommand.command, scope.gatewayCommand.params).then(
                    (commandResult) => {
                        if (commandResult) {
                            if (commandResult.output) {
                                scope.gatewayCommand.commandOutput = commandResult.output;
                            } else if (commandResult.error) {
                                if (angular.equals(commandResult.error, types.gatewayCommandNotSupported.value)) {
                                    var toastParent = angular.element(".tk-ace-command-output", $document);
                                    toast.showError($translate.instant("gateway-command.not-supported"), toastParent.closest(".toast-parent"), "bottom right");
                                    scope.gatewayCommand.commandOutput = $translate.instant("gateway-command.not-supported").toString();
                                }
                            } else {
                                scope.gatewayCommand.commandOutput = angular.toJson(commandResult, true)
                            }
                        } else {
                            scope.gatewayCommand.commandOutput = '';
                        }
                    },
                    (rejection) => {
                        scope.gatewayCommand.commandOutput = 'Error executing gateway command.';
                        if (rejection.status) {
                            scope.gatewayCommand.commandOutput += '\nStatus: ' + rejection.status;
                        }
                        if (rejection.data) {
                            scope.gatewayCommand.commandOutput += '\nError: ';
                            if (rejection.data.message) {
                                scope.gatewayCommand.commandOutput += rejection.data.message;
                            } else {
                                scope.gatewayCommand.commandOutput += rejection.data;
                            }
                        }
                    }
            );
        };

        function loadGatewayFrequencyInfo() {
            scope.gatewayFrequencyBandInfo = null;
            if (scope.gateway.gatewayModelId) {
                gatewayModelService.getGatewayModel(scope.gateway.gatewayModelId.id).then(
                    (gatewayModel) => {
                        scope.gatewayFrequencyBandInfo = types.gatewayFrequency[gatewayModel.gatewayFrequency].info;
                        scope.gatewayModelChannels = gatewayModel.additionalInfo ? gatewayModel.additionalInfo.channels : '';
                    }
                );
            }
        }

        function watchStatsTimewindow() {
            scope.statsTimewindowWatch = scope.$watch("statsQuery.timewindow", function(newVal, prevVal) {
                if (newVal && !angular.equals(newVal, prevVal)) {
                    updateGatewayStatsSubscription();
                }
            }, true);
        }

        function stopWatchStatsTimewindow() {
            if (scope.statsTimewindowWatch) {
                scope.statsTimewindowWatch();
                scope.statsTimewindowWatch = null;
            }
        }

        function updateGatewayStateParameters() {
            if (scope.gatewayState.online && !scope.gateway.disabled) {
                scope.onlineStatus = $translate.instant('gateway.online');
                scope.onlineStatusColor = '#1a901a';
            } else {
                scope.onlineStatus = scope.gateway.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.offline');
                scope.onlineStatusColor = '#ff0000';
            }
        }

        function reset() {

            scope.gatewayCommand.command = null;
            scope.gatewayCommand.params = {};
            scope.gatewayCommand.commandOutput = '';

            stopWatchStatsTimewindow();

            scope.gatewayState = {};

            scope.gatewayStats = [];
            scope.lastGatewayStats = {};

            if (scope.gatewayStateSubscriptionHandle) {
                scope.gatewayStateSubscriptionHandle();
                scope.gatewayStateSubscriptionHandle = null;
            }
            if (scope.gatewayStatsSubscriptionHandle) {
                scope.gatewayStatsSubscriptionHandle();
                scope.gatewayStatsSubscriptionHandle = null;
            }

            scope.lastActivityTime = null;

            updateGatewayStateParameters();

            scope.currentGatewayLat = null;
            scope.currentGatewayLng = null;
            scope.currentGatewayAlt = null;

            scope.currentGatewayCenter = {
                lat: 0,
                lng: 0,
                zoom: 1
            };

            scope.markers = {};

            scope.statsQuery.timewindow = {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            };
            scope.statsQuery.order = '-ts';
            scope.statsQuery.limit = 15;
            scope.statsQuery.page = 1;
            scope.statsQuery.search = null;

            watchStatsTimewindow();
        }

        function createGatewaySubscriptions() {
            scope.gatewayStateSubscriptionHandle = gatewayService.subscribeForGatewayStateData(scope.gateway.id.id,
                onGatewayStateData);
            scope.gatewayStatsSubscriptionHandle = gatewayService.subscribeForGatewayStatsData(scope.gateway.id.id,
                scope.statsQuery.timewindow, onGatewayStatsData, onGatewayStatsDataReconnected);
        }

        function updateGatewayStatsSubscription() {
            if (scope.gatewayStatsSubscriptionHandle) {
                scope.gatewayStatsSubscriptionHandle();
                scope.gatewayStatsSubscriptionHandle = null;
            }
            scope.gatewayStats = [];
            scope.lastGatewayStats = {};

            updateGatewayLocation();
            updateGatewayStatsRows();

            scope.gatewayStatsSubscriptionHandle = gatewayService.subscribeForGatewayStatsData(scope.gateway.id.id,
                scope.statsQuery.timewindow, onGatewayStatsData, onGatewayStatsDataReconnected);
        }

        function onGatewayStateData(gatewayState) {
            scope.$apply(() => {
                scope.gatewayState = gatewayState;
                if (scope.gatewayState.lastActivityTime) {
                    scope.lastActivityTime = $filter('date')(scope.gatewayState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastActivityTime = null;
                }
                updateGatewayStateParameters();
            });
        }

        function onGatewayStatsData(gatewayStats) {
            scope.$apply(() => {
                if (gatewayStats && gatewayStats.length) {
                    scope.gatewayStats = scope.gatewayStats.concat(gatewayStats);
                }
                if (scope.gatewayStats.length) {
                    scope.gatewayStats = $filter('orderBy')(scope.gatewayStats, '-ts');
                    scope.lastGatewayStats = scope.gatewayStats[0];
                }
                updateGatewayLocation();
                updateGatewayStatsRows();
            });
        }

        function onGatewayStatsDataReconnected() {
            scope.$apply(() => {
                scope.gatewayStats = [];
                scope.lastGatewayStats = {};
                updateGatewayLocation();
                updateGatewayStatsRows();
            });
        }

        function updateGatewayStatsRows() {
            var result = $filter('orderBy')(scope.gatewayStats, scope.statsQuery.order);
            if (scope.statsQuery.search != null) {
                result = $filter('filter')(result, {$: scope.statsQuery.search});
            }
            scope.statsRowsCount = result.length;
            var startIndex = scope.statsQuery.limit * (scope.statsQuery.page - 1);
            scope.gatewayStatsRows = result.slice(startIndex, startIndex + scope.statsQuery.limit);
        }

        function updateGatewayLocation() {
            var lat = null, lng = null, altitude = null;

            if (angular.isDefined(scope.lastGatewayStats.latitude)
                && scope.lastGatewayStats.latitude != null
                && scope.lastGatewayStats.latitude !== 0) {
                lat = scope.lastGatewayStats.latitude;
            } else if (angular.isDefined(scope.gateway.lat)) {
                lat = scope.gateway.lat;
            }
            if (angular.isDefined(scope.lastGatewayStats.longitude)
                && scope.lastGatewayStats.longitude != null
                && scope.lastGatewayStats.longitude !== 0) {
                lng = scope.lastGatewayStats.longitude;
            } else if (angular.isDefined(scope.gateway.lng)) {
                lng = scope.gateway.lng;
            }
            if (angular.isDefined(scope.lastGatewayStats.altitude)
                && scope.lastGatewayStats.altitude != null
                && scope.lastGatewayStats.altitude !== 0) {
                altitude = scope.lastGatewayStats.altitude;
            } else if (angular.isDefined(scope.gateway.altitude)) {
                altitude = scope.gateway.altitude;
            }
            scope.currentGatewayLat = lat;
            scope.currentGatewayLng = lng;
            scope.currentGatewayAlt = altitude;
            if (scope.currentGatewayLat != null && scope.currentGatewayLng != null) {
                scope.currentGatewayCenter.lat = scope.currentGatewayLat;
                scope.currentGatewayCenter.lng = scope.currentGatewayLng;
                if (!scope.markers.gateway) {
                    scope.currentGatewayCenter.zoom = defaultMapZoom;
                }
                scope.markers.gateway = {
                    lat: scope.currentGatewayLat,
                    lng: scope.currentGatewayLng
                }
            } else {
                scope.currentGatewayCenter.lat = 0;
                scope.currentGatewayCenter.lng = 0;
                scope.currentGatewayCenter.zoom = 1;
                delete scope.markers.gateway;
            }
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gateway: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway.directive.js